var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.pram.id ? "编辑商品名称标签" : "新增商品名称标签",
        top: "100px",
        width: "640px",
        "destroy-on-close": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleDialogClose,
      },
    },
    [
      _c(
        "el-form",
        { ref: "pram", attrs: { "label-width": "150px", model: _vm.pram } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "标签名称：",
                prop: "labelName",
                rules: _vm.labelNameRules,
              },
            },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  maxlength: "20",
                  "show-word-limit": "",
                  placeholder: "请输入",
                },
                on: { input: _vm.handleLabelNameValidate },
                model: {
                  value: _vm.pram.labelName,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "labelName", $$v)
                  },
                  expression: "pram.labelName",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form-tip" }, [
                _vm._v("此标签名称只在后台展示，与移动端效果无关"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "商品来源：",
                prop: "productSource",
                rules: _vm.requiredRules("请选择商品来源"),
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.pram.productSource,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "productSource", $$v)
                    },
                    expression: "pram.productSource",
                  },
                },
                [_c("el-radio", { attrs: { label: 1 } }, [_vm._v("普通商品")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "标签图：",
                prop: "labelImage",
                rules: _vm.requiredRules("请上传标签图"),
              },
            },
            [
              _vm.userType === 1
                ? _c("div", { staticClass: "upload-row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: { click: _vm.modalPicTap },
                      },
                      [
                        _vm.pram.labelImage
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", {
                                attrs: { src: _vm.pram.labelImage },
                              }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.pram.labelImage
                      ? _c("i", {
                          staticClass: "el-icon-delete remove-icon",
                          on: { click: _vm.removeImg },
                        })
                      : _vm._e(),
                  ])
                : _c(
                    "div",
                    { staticClass: "upload-row" },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "bg-uploader",
                          attrs: {
                            action: "",
                            "show-file-list": false,
                            "http-request": _vm.handleLocalUpload,
                            "before-upload": _vm.beforeUpload,
                            accept: "image/png,image/jpeg,image/jpg",
                          },
                        },
                        [
                          _vm.pram.labelImage
                            ? _c("div", { staticClass: "pictrue" }, [
                                _c("img", {
                                  attrs: { src: _vm.pram.labelImage },
                                }),
                              ])
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.pram.labelImage
                        ? _c("i", {
                            staticClass: "el-icon-delete remove-icon",
                            on: { click: _vm.removeImg },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "form-tip" }, [
                _vm._v("支持上传png/jpg的图片格式，上传大小≤100KB"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "标签位置：", prop: "labelPosition" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.pram.labelPosition,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "labelPosition", $$v)
                    },
                    expression: "pram.labelPosition",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v("位于商品名左侧"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "关联商品价格类型：", prop: "priceType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.pram.priceType,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "priceType", $$v)
                    },
                    expression: "pram.priceType",
                  },
                },
                _vm._l(_vm.priceTypeOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-tip" }, [
                _vm._v("新人价商品必选，其余商品可不选"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "状态：",
                prop: "status",
                rules: _vm.requiredRules("请选择状态"),
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.pram.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "status", $$v)
                    },
                    expression: "pram.status",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-tip" }, [
                _vm._v("启用后该配置在移动端生效，否则不生效"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handerSubmit },
            },
            [_vm._v("保存")]
          ),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.closeEdit } }, [_vm._v("取消")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }